import { collection, query, getCountFromServer } from "firebase/firestore";
import { ListServiceOpts } from "../../../types";
import { db } from "../../../firebase";

export type ExecutionCountService = (
  agentId: string,
  externalautomationId: string,
  opts?: ListServiceOpts
) => Promise<number>;

const count: ExecutionCountService = async (
  agentId,
  externalautomationId,
  opts = {}
) => {
  const collectionRef = collection(
    db,
    `/agent/${agentId}/externalautomation/${externalautomationId}/execution`
  );
  const q =
    typeof opts.listQueryFn === "function"
      ? opts.listQueryFn(collectionRef)
      : query(collectionRef);
  const snapshot = await getCountFromServer(q);

  return snapshot.data().count;
};

export default count;
